export default __webpack_public_path__ + "static/media/tronko.be388f82.jpg";